module.exports = __webpack_public_path__ + "e198a012990aa8376839c4698e29cd4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/deloitte_psp_2022_chart.png
// module id = 1662
// module chunks = 0